export default {
  setEcofrostList: (state, ecofrostList) => {
    state.ecofrostList = ecofrostList;
  },

  setEcofrostCurrent: (state, ecofrostCurrent) => {
    state.ecofrostCurrent = ecofrostCurrent;
  },

  setEcofrostPagination: (state, pagination) => {
    state.ecofrostPagination = pagination;
  },

  setEcofrostLoading: (state, loading) => {
    state.ecofrostLoading = loading;
  }
};
